<template>
  <div>
    <div class="container">
      <div class="top">
        <div style="display: flex;align-items: center;">
          <el-button @click="exportExcel" type="primary">导出数据</el-button>
          <el-button
              type="primary"
              plain
              @click="openRules"
          >绩效规则</el-button>
        </div>
        <div class="search">
          <el-date-picker
              v-model="dateValue"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              @change="dateChange"
              :clearable="false"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              end-placeholder="结束日期">
          </el-date-picker>
          <el-select style="margin: 0 10px;width: 240px" v-model="orgIds" multiple collapse-tags placeholder="组织类型">
            <el-option
                v-for="item in orgList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="selectValue" multiple collapse-tags placeholder="得分项" @change="selectChange">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button style="margin-left: 10px" type="primary" @click="searchTwo"
          >查询</el-button
          >
        </div>
      </div>
      <coententTable
          :y="580"
          @handleTableChange="handleTableChange"
          @onShowSizeChange="onShowSizeChange"
          :columns="columns"
          :dataSource="dataSource"
          :loading="loading"
          ref="tableRef"
      >
      </coententTable>
    </div>
    <PerformanceRules v-if="dialogVisible" @handleClose="handleClose" :dialogVisible="dialogVisible"></PerformanceRules>
  </div>
</template>

<script>
//创建时间：2023/10/25 10:31:31
import {getOrgList, getStateList} from "./performance";
import coententTable from "@/components/coentent_table.vue";
import PerformanceRules from "./performance_rules.vue"
import ExportJsonExcel from "js-export-excel"
import { message } from 'ant-design-vue';
export default {
  components: {
    coententTable,
    PerformanceRules
  },
  data() {
    return {
      dateValue:["2023-10-01","2023-10-30"],
      dialogVisible:false,
      dataSource:[],
      pickerOptions:{
        disabledDate(time) {
          let date = new Date(time);
          let year = date.getFullYear();
          let month = date.getMonth()+1;
          let day = date.getDate();
          return year<2023||year<=2023&&month<10&&day>=1;
        }
      },
      formData:{
        typeId: "",
        startTime: "2023-10-01",
        endTime: "2023-10-30",
      },
      loading: true,
      columns:[
        {
          title: "排名",
          dataIndex: "index",
          width:90,
          customRender: (text, record, index) => index + 1,
        },
        {
          title: "组织机构",
          dataIndex: "orgName",
          width:200,
          ellipsis: true,
        },
        {
          title: "类型",
          dataIndex: "typeName",
          ellipsis: true,
        },
        {
          title: "登录数",
          dataIndex: "loginDay",
          ellipsis: true,
        },
        {
          title: "登录得分",
          colSpan:1,
          dataIndex: "loginMark",
          ellipsis: true,
          customRender: (value) => {
            const obj = {
              children: value,
              attrs: {},
            };
            if(!this.selectValue.includes('1')){
              obj.attrs.colSpan = 0;
            }else{
              obj.attrs.colSpan = 1;
            }
            return obj
          }
        },
        {
          title: "发稿数",
          dataIndex: "reports",
          ellipsis: true,
        },
        {
          title: "发稿得分",
          colSpan:1,
          dataIndex: "reportsMark",
          ellipsis: true,
          customRender: (value) => {
            const obj = {
              children: value,
              attrs: {},
            };
            if(!this.selectValue.includes('2')){
              obj.attrs.colSpan = 0;
            }else{
              obj.attrs.colSpan = 1;
            }
            return obj
          }
        },
        {
          title: "报送得分",
          colSpan:1,
          dataIndex: "adoptMark",
          ellipsis: true,
          customRender: (value) => {
            const obj = {
              children: value,
              attrs: {},
            };
            if(!this.selectValue.includes('3')){
              obj.attrs.colSpan = 0;
            }else{
              obj.attrs.colSpan = 1;
            }
            return obj
          }
        },
        {
          title: "总分",
          dataIndex: "countMark",
          ellipsis: true,
        },
      ],
      selectValue:["1","2","3"],
      orgIds:[],
      orgList:[],
      options:[
        {
          value: "1",
          label: '登录得分'
        },
        {
          value: "2",
          label: '发稿得分'
        },
        {
          value: "3",
          label: '报送得分'
        }
      ]
    }
  },
  methods: {
    netWork(){
      this.formData.typeId = this.orgIds.join(",");
      getStateList(this.formData).then(res=>{
        if(res.code===0){
          this.loading = false;
          this.dataSource = res.data
        }
      })
    },
    selectChange(val){
      this.columns.map(item=>{
        if(item.title === "登录得分"){
          if(val.includes("1")){
            item.colSpan = 1;
          }else{
            item.colSpan = 0;
          }
        }
        if(item.title === "发稿得分"){
          if(val.includes("2")){
            item.colSpan = 1;
          }else{
            item.colSpan = 0;
          }
        }
        if(item.title === "报送得分"){
          if(val.includes("3")){
            item.colSpan = 1;
          }else{
            item.colSpan = 0;
          }
        }
      })
      this.$refs.tableRef.$forceUpdate();
    },
    searchTwo(){
      if(this.orgIds.length===0){
        message.error("组织类型不能为空");
        return;
      }
      this.loading = true;
      this.netWork();
    },
    openRules(){
      this.dialogVisible = true;
    },
    handleClose(){
      this.dialogVisible = false;
    },
    dateChange(val){
      this.formData.startTime = val[0];
      this.formData.endTime = val[1];
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.formData.current = current;
      this.getListPage();
    },
    handleTableChange(page, pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.formData.current = 1;
      this.formData.size = pageSize;
      this.getListPage();
    },
    exportExcel(){
      let startArr = this.formData.startTime.split("-")
      let startTime = startArr[0]+"年"+startArr[1]+"月"+startArr[2]+"日";
      let endArr = this.formData.endTime.split("-");
      let endTime = endArr[0]+"年"+endArr[1]+"月"+endArr[2]+"日";
      let option = {
        fileName:startTime+"-"+endTime+"绩效统计",
        datas:[]
      };
      let sheetFilter = [];
      let sheetHeader = [];
      this.columns.map(item=>{
        if(item.colSpan!==0){
          sheetFilter.push(item.dataIndex);
          sheetHeader.push(item.title);
        }
      })
      option.datas = [
        {
          sheetData:this.dataSource.map((item,index)=>{
            const result = {};
            this.columns.map(i=>{
              if(i.colSpan!==0) {
                result[i.dataIndex] = item[i.dataIndex] === null || item[i.dataIndex] === undefined ? index + 1 : item[i.dataIndex]
              }
            })
            return result;
          }),
          sheetName:option.fileName,
          sheetFilter,
          sheetHeader,
          columnWidths: this.columns.map(() => 10),
        }
      ]
      const toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    },
  },
  mounted() {
    getOrgList().then(res=>{
      this.orgList = res.data
      this.orgIds = res.data.map(item=>{
        return item.id
      })
      this.netWork()
    })
  },
}
</script>

<style scoped lang="less">
/deep/ .el-range-editor.el-input__inner{
  justify-content: space-between;
}
/deep/.el-date-editor .el-range-input{
  width: 100px;
}
.container {
  .top {
    padding: 24px 24px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .search {
      display: flex;
    }
  }
}
</style>